import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrServiceCategory.ts
var t = () => e("serviceCategory");
//#endregion
export { t as useTrServiceCategory };
